module.exports = __webpack_public_path__ + "media/img/files/file-4-b0d6d7f0484f1d58b3dc708619a14bb2.jpg";